var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesabledLeftArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66664 0H21.6664C22.583 0 23.333 0.74999 23.333 1.66664V18.3331C23.333 19.2497 22.583 19.9997 21.6664 19.9997H1.66664C0.749987 19.9997 0 19.2497 0 18.3331V1.66664C0 0.74999 0.749987 0 1.66664 0ZM1.66664 18.3331H14.9998V10.8332H6.49991L9.49987 13.8331L8.33322 14.9998L3.33329 9.99986L8.33322 4.99993L9.49987 6.16658L6.49991 9.16654H14.9998V1.66664H1.66664V18.3331Z",
    fill: "#F2F3F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesabledLeftArrowIcon);
export default __webpack_public_path__ + "static/media/DesabledLeftArrowIcon.8064196c8bee2540ac94c50ff624018a.svg";
export { ForwardRef as ReactComponent };